<template>
  <div
    class="flex_box"
    :style="styleMerge"
  >
    <div class="current-active" />
    <img
      v-if="viewData.hotZoneImg.config.imgUrl"
      style="width: 100%"
      :src="viewData.hotZoneImg.config.imgUrl"
      alt=""
    >
    <div v-else>
      请选择图片
    </div>
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpHotZoneImg',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      inputVal: null,
      viewData: {
        hotZoneImg: {
          config: {
            imgUrl:''
          }
        }
      }
    }
  },
  created () {
    console.log('SpHotZoneImg:this.viewData', this.viewData)
    console.log('SpHotZoneImg:this.props', this.props)
  },
  mounted () {
    // console.log('spinput-viewData',this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
